/**
 * Component Type Endpoints
 */

export const apiPostComponentType = async (
  componentType: ComponentTypeCreateUpdate,
): Promise<AxiosResponse<ComponentType>> => {
  return await userManagementAxiosInstance.post('component_types', componentType);
};

export const apiGetComponentTypes = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedComponentType>> => {
  return await userManagementAxiosInstance.get(
    `component_types?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetComponentType = async (
  id: string | number,
): Promise<AxiosResponse<ComponentType>> => {
  return await userManagementAxiosInstance.get(`component_types/${id}`);
};

export const apiPutComponentType = async (
  componentType: ComponentTypeCreateUpdate,
): Promise<AxiosResponse<ComponentType>> => {
  return await userManagementAxiosInstance.put(
    `component_types/${componentType.id}`,
    componentType,
  );
};

export const apiDeleteComponentType = async (
  id: string | number,
): Promise<AxiosResponse<ComponentType>> => {
  return await userManagementAxiosInstance.delete(`component_types/${id}`);
};
